var map = {
	"./Carre-alsacien1.webp": 2539,
	"./Carre-alsacien2.webp": 56,
	"./Carre-alsacien3.webp": 819,
	"./Dôme palmier1.webp": 8265,
	"./Dôme palmier2.webp": 5037,
	"./Dôme palmier3.webp": 7501,
	"./Kimono1.webp": 4019,
	"./Kimono2.webp": 1854,
	"./Kimono3.webp": 706,
	"./Lakme1.webp": 1677,
	"./Lakme2.webp": 8682,
	"./Lakme3.webp": 3577,
	"./Lanterne tribal1.webp": 8347,
	"./Lanterne tribal2.webp": 8252,
	"./Lanterne tribal3.webp": 6761,
	"./Moulin-rouge1.webp": 7371,
	"./Moulin-rouge2.webp": 4631,
	"./Moulin-rouge3.webp": 9527,
	"./Pagode1.webp": 1954,
	"./Pagode2.webp": 4705,
	"./Pagode3.webp": 3817,
	"./Petite-robe-noire1.webp": 1086,
	"./Plissé coton et soie1.webp": 808,
	"./Plissé coton et soie2.webp": 3275,
	"./Plissé coton et soie3.webp": 3618,
	"./Taj Mahal-2.webp": 3518,
	"./Taj Mahal.webp": 9487,
	"./Taj Mahal3.webp": 1101,
	"./café bleu 1.webp": 6064,
	"./café bleu 2.webp": 3874,
	"./café bleu 3.webp": 8037,
	"./carre-espagnol1.webp": 3061,
	"./carre-espagnol2.webp": 1663,
	"./carre-espagnol3.webp": 6133,
	"./forage clay 1.webp": 4306,
	"./forage clay 2.webp": 4835,
	"./forage clay 3.webp": 4461,
	"./makeba 1.webp": 5356,
	"./makeba 2.webp": 1852,
	"./makeba 3.webp": 4395,
	"./pagode4.webp": 3871,
	"./pagode5.webp": 2963,
	"./pagode6.webp": 9995,
	"./petite-robe-noire2.webp": 3152,
	"./petite-robe-noire3.webp": 9895,
	"./wonderfull 1.webp": 6139,
	"./wonderfull 2.webp": 1344,
	"./wonderfull 3.webp": 8916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8349;